import { render, staticRenderFns } from "./ExaminationPj.vue?vue&type=template&id=0dc28bec&scoped=true"
import script from "./ExaminationPj.vue?vue&type=script&lang=js"
export * from "./ExaminationPj.vue?vue&type=script&lang=js"
import style0 from "./ExaminationPj.vue?vue&type=style&index=0&id=0dc28bec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dc28bec",
  null
  
)

export default component.exports